require('./ContractAccordion.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

// @components
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');

class ContractAccordion extends React.Component {

    buildRow(components) {
        const ret = components.map(element => this.buildRowItem(element, components.length));
        return <div className="form-item row"> {ret} </div>;
    }

    buildRowItem(component, rowLength) {
        //If size is not set in the compoennt, it assings a size
        const { buildComponent } = this.props;
        const componentSize = (component.size) ? 'col-xs-' + component.size : 'col-xs-' + Math.floor(12 / rowLength);
        const content = buildComponent(component);
        return (
            <div className={componentSize} key={component.id}>
                {content}
            </div>
        );
    }

    buildTabForm(component) {
        return component.grid.map(element => this.buildRow(element));
    }

    render() {
        const {
            isVisible,
            component,
        } = this.props;

        const content = (isVisible) ? (
            <Accordion customClassName="contract-accordion" isExpanded={true}>
                <AccordionHeader
                    name="AccordionHeader"
                    isRightArrowPosition={true}
                    >
                    <FormattedText className="subtitle" value={component.label} />
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    {this.buildTabForm(component)}
                </AccordionBody>
            </Accordion>
        ) : (
            null
        );

        return content;
    }
}

ContractAccordion.propTypes = {
    buildComponent: PropTypes.func,
    component: PropTypes.object,
    isVisible: PropTypes.bool.isRequired
};

module.exports = ContractAccordion;